module.exports = __webpack_public_path__ + "static/media/havda.496fdbe8.mp3";